import PropTypes from 'prop-types';
import * as styles from './styles/styles.module.scss';

const STATUS_TO_WORD_HASH = {
  A: 'Active',
  D: 'Deleted',
  R: 'Redeemed',
  S: 'Sent'
};

const GiftDisplayItem = ({ gift, handleEditGiftClick, handleResendGiftClick, handleDeactivateGiftClick }) => {
  const dt = gift.metadata.deliveryDate ? new Date(gift.metadata.deliveryDate) : null;
  let resendButton;
  if (gift.resent) {
    resendButton = (
      <button className={styles.actionButton} disabled>
        Sent
      </button>
    );
  } else {
    resendButton = (
      <button className={styles.actionButton} onClick={() => handleResendGiftClick(gift.id)}>
        Resend
      </button>
    );
  }
  return (
    <div className={styles.couponCard}>
      <h4>{`Code: ${gift.code}`}</h4>
      <h4>{`Plan Type: ${gift.planType}`}</h4>
      <h4>{`Status: ${STATUS_TO_WORD_HASH[gift.metadata.status]}`}</h4>
      <h4>{`Delivery date: ${dt}`}</h4>
      <h4>{`Delivery Timezone: ${gift.metadata.timezoneIdentifier}`}</h4>
      <h4>{`Sender: ${gift.senderName}`}</h4>
      <h4>{`Sender email: ${gift.senderEmail}`}</h4>
      <h4>{`Receipient: ${gift.recipientName}`}</h4>
      <h4>{`Receipient email: ${gift.recipientEmail}`}</h4>
      <h4>
        Print link:{' '}
        <a target="_blank" href={`/gift/preview?code=${gift.code}`}>
          here
        </a>
      </h4>
      <p>{`Message: ${gift.message}`}</p>
      <button className={styles.actionButton} onClick={handleEditGiftClick}>
        Edit
      </button>
      {resendButton}
      <button className={styles.actionButton} onClick={() => handleDeactivateGiftClick(gift.id)}>Deactivate</button>
    </div>
  );
};

GiftDisplayItem.propTypes = {
  gift: PropTypes.object.isRequired,
  handleEditGiftClick: PropTypes.func.isRequired,
  handleResendGiftClick: PropTypes.func.isRequired
};

GiftDisplayItem.defaultProps = {};

export default GiftDisplayItem;
